import React, { useEffect, useState } from "react";
import SvgLines from "react-mt-svg-lines";

export default function Callouts({
  videoOver,
  page,
  introFinished,
  homeOverlay,
  resized,
}) {
  const [activeLinkHome, setActiveLinkHome] = useState(null);
  const [activeLinkRemote, setActiveLinkRemote] = useState(null);
  const [textBoxHome, setTextBoxHome] = useState(null);
  const [textBoxTitle, setTextBoxTitle] = useState(null);

  const [hideTextBox, setHideTextBox] = useState(true);

  const changeActiveLinkHome = (newSection) => {
    setActiveLinkHome((prevState) => {
      if (prevState !== null && document.getElementById(prevState)) {
        document.getElementById(prevState).classList.remove("callout-active");
      }
      prevState = newSection;
      return prevState;
    });
  };

  const changeActiveLinkRemote = (newSection) => {
    setActiveLinkRemote((prevState) => {
      if (prevState !== null) {
        document
          .getElementById(prevState)
          .classList.remove("callout-btn-overlay-active");
      }
      prevState = newSection;
      document
        .getElementById(prevState)
        .classList.remove("callout-btn-overlay");
      document
        .getElementById(prevState)
        .classList.add("callout-btn-overlay-active");
      console.log(document.getElementById(prevState).classList);
      return prevState;
    });
  };
  return (
    <>
      {page === "home" && (
        <>
          <SvgLines
            animate={
              (videoOver && introFinished) || resized
                ? 600
                : videoOver && !introFinished
                ? 1200
                : 22300
            }
            // stagger={100}
            duration={(videoOver && introFinished) || resized ? 1000 : 2000}
          >
            <svg
              className="callouts"
              style={{
                marginLeft: "0px",
                zIndex: 19,
                opacity: videoOver && homeOverlay ? 1 : 0.9,
                animation: videoOver ? "none" : "0.3s linear forwards fadeIn",
                animationDelay: videoOver ? "0s !important" : "4s",
              }}
            >
              <path
                fill="none"
                stroke="#ED2590"
                strokeWidth={videoOver && homeOverlay ? 2.5 : 1}
                strokeMiterLimit={10}
                d="M95.73,557.34H31.37V493H95.73Zm-63.36-1H94.73V494H32.37Z"
                transform="translate(3.5 -57.89)"
              />
              <path
                fill="none"
                stroke="#ED2590"
                strokeWidth={videoOver && homeOverlay ? 2.5 : 1}
                strokeMiterLimit={10}
                d="M451.76,557.34H101V493H451.76Zm-349.74-1H450.76V494H102Z"
                transform="translate(2 -57.89)"
              />
              <path
                fill="none"
                stroke="#ED2590"
                strokeWidth={videoOver && homeOverlay ? 2.5 : 1}
                strokeMiterLimit={10}
                d="M522.82,557.34H458.45V493h64.37Zm-63.37-1h62.37V494H459.45Z"
                transform="translate(-0.5 -57.89)"
              />
              <path
                fill="none"
                stroke="#ED2590"
                strokeWidth={videoOver && homeOverlay ? 2.5 : 1}
                strokeMiterLimit={10}
                d="M593.77,557.34H529.41V493h64.36Zm-63.36-1h62.36V494H530.41Z"
                transform="translate(-1 -57.89)"
              />
              <path
                fill="none"
                stroke="#ED2590"
                strokeWidth={videoOver && homeOverlay ? 2.5 : 1}
                strokeMiterLimit={10}
                d="M665.18,557.34H600.82V493h64.36Zm-63.36-1h62.36V494H601.82Z"
                transform="translate(-2 -57.89)"
              />
              <path
                fill="none"
                stroke="#ED2590"
                strokeWidth={videoOver && homeOverlay ? 2.5 : 1}
                strokeMiterLimit={10}
                d="M736.12,557.34H671.75V493h64.37Zm-63.37-1h62.37V494H672.75Z"
                transform="translate(-2.5 -57.89)"
              />
              <path
                fill="none"
                stroke="#ED2590"
                strokeWidth={videoOver && homeOverlay ? 2.5 : 1}
                strokeMiterLimit={10}
                d="M807.18,557.34H742.82V493h64.36Zm-63.36-1h62.36V494H743.82Z"
                transform="translate(-3 -57.89)"
              />
              <path
                fill="none"
                stroke="#ED2590"
                strokeWidth={videoOver && homeOverlay ? 2.5 : 1}
                strokeMiterLimit={10}
                d="M878.68,557.34H814.32V493h64.36Zm-63.36-1h62.36V494H815.32Z"
                transform="translate(-3.8 -57.89)"
              />
              <path
                fill="none"
                stroke="#ED2590"
                strokeWidth={videoOver && homeOverlay ? 2.5 : 1}
                strokeMiterLimit={10}
                d="M941.41,271.15H439.71V132.43h501.7Zm-500.7-1h499.7V133.43H440.71Z"
                transform="translate(-2 -53.89)"
              />
            </svg>
          </SvgLines>

          {/* Start new buttons */}
          <div
            className="callout-btn"
            id="settings"
            style={{
              position: "absolute",
              height: "63px",
              width: "63px",
              top: "calc(50% + 164px)",
              left: "calc(50% + 329px)",
              backgroundColor: "rgba(255,0,153,0.4)",
              zIndex: 19,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: 'url("./images/webos-cursor.png"), auto',
            }}
            onClick={() => {
              const el = document.getElementById("settings").classList;
              console.log(el);
              if (el.contains("callout-active")) {
                el.remove("callout-active");
              } else {
                el.add("callout-active");
              }
            }}
            onMouseOver={() => {
              setActiveLinkHome("settings");
              document
                .getElementById("settings")
                .classList.add("callout-active");
              setTextBoxHome(
                "Access the TV settings to adjust screen settings, audio setttings, internet connection, and more."
              );
              setTextBoxTitle("TV Settings");
              document
                .getElementById("home-text-box")
                .classList.add("callout-active");
            }}
            onMouseLeave={() => {
              setActiveLinkHome(null);
              document
                .getElementById("settings")
                .classList.remove("callout-active");
              setTextBoxHome(null);
              document
                .getElementById("home-text-box")
                .classList.remove("callout-active");
            }}
          ></div>
          <div
            className="callout-btn"
            id="edit"
            style={{
              position: "absolute",
              height: "63px",
              width: "63px",
              top: "calc(50% + 164px)",
              left: "calc(50% + 259px)",
              backgroundColor: "rgba(255,0,153,0.4)",
              zIndex: 19,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: 'url("./images/webos-cursor.png"), auto',
            }}
            onClick={() => {
              const el = document.getElementById("edit").classList;
              console.log(el);
              if (el.contains("callout-active")) {
                el.remove("callout-active");
              } else {
                el.add("callout-active");
              }
            }}
            onMouseOver={() => {
              setActiveLinkHome("edit");
              document.getElementById("edit").classList.add("callout-active");
              setTextBoxHome(
                "Remove or edit the position of apps in your home bar."
              );
              setTextBoxTitle("Edit Home Bar");
              document
                .getElementById("home-text-box")
                .classList.add("callout-active");
            }}
            onMouseLeave={() => {
              setActiveLinkHome(null);
              document
                .getElementById("edit")
                .classList.remove("callout-active");
              setTextBoxHome(null);
              document
                .getElementById("home-text-box")
                .classList.remove("callout-active");
            }}
          ></div>
          <div
            className="callout-btn"
            id="sponsored"
            style={{
              position: "absolute",
              height: "137px",
              width: "500px",
              top: "calc(50% - 193px)",
              left: "calc(50% - 43px)",
              backgroundColor: "rgba(255,0,153,0.4)",
              zIndex: 19,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: 'url("./images/webos-cursor.png"), auto',
            }}
            onClick={() => {
              const el = document.getElementById("sponsored").classList;
              console.log(el);
              if (el.contains("callout-active")) {
                el.remove("callout-active");
              } else {
                el.add("callout-active");
              }
            }}
            onMouseOver={() => {
              setActiveLinkHome("sponsored");
              document
                .getElementById("sponsored")
                .classList.add("callout-active");
              setTextBoxHome(
                "Easily access a dedicated area for sponsored webOS TV content anytime."
              );
              setTextBoxTitle("Sponsored Content");
              document
                .getElementById("home-text-box")
                .classList.add("callout-active");
            }}
            onMouseLeave={() => {
              setActiveLinkHome(null);
              document
                .getElementById("sponsored")
                .classList.remove("callout-active");
              setTextBoxHome(null);
              document
                .getElementById("home-text-box")
                .classList.remove("callout-active");
            }}
          ></div>
          <div
            className="callout-btn"
            id="search"
            style={{
              position: "absolute",
              height: "63px",
              width: "63px",
              top: "calc(50% + 164px)",
              left: "calc(50% + 189px)",
              backgroundColor: "rgba(255,0,153,0.4)",
              zIndex: 19,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: 'url("./images/webos-cursor.png"), auto',
            }}
            onClick={() => {
              const el = document.getElementById("search").classList;
              console.log(el);
              if (el.contains("callout-active")) {
                el.remove("callout-active");
              } else {
                el.add("callout-active");
              }
            }}
            onMouseOver={() => {
              setActiveLinkHome("search");
              document.getElementById("search").classList.add("callout-active");
              setTextBoxHome(
                "Use the powerful capabilities of TV search to find exactly what you want."
              );
              setTextBoxTitle("Search");
              document
                .getElementById("home-text-box")
                .classList.add("callout-active");
            }}
            onMouseLeave={() => {
              setActiveLinkHome(null);
              document
                .getElementById("search")
                .classList.remove("callout-active");
              setTextBoxHome(null);
              document
                .getElementById("home-text-box")
                .classList.remove("callout-active");
            }}
          ></div>
          <div
            className="callout-btn"
            id="thinq-home"
            style={{
              position: "absolute",
              height: "63px",
              width: "63px",
              top: "calc(50% + 164px)",
              left: "calc(50% + 118px)",
              backgroundColor: "rgba(255,0,153,0.4)",
              zIndex: 19,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: 'url("./images/webos-cursor.png"), auto',
            }}
            onClick={() => {
              const el = document.getElementById("thinq-home").classList;
              if (el.contains("callout-active")) {
                el.remove("callout-active");
              } else {
                el.add("callout-active");
              }
            }}
            onMouseOver={() => {
              setActiveLinkHome("thinq-home");
              document
                .getElementById("thinq-home")
                .classList.add("callout-active");
              setTextBoxHome(
                "Control your smart devices from the home dashboard powered by ThinQ AI."
              );
              setTextBoxTitle("ThinQ Home Dashboard");
              document
                .getElementById("home-text-box")
                .classList.add("callout-active");
            }}
            onMouseLeave={() => {
              setActiveLinkHome(null);
              document
                .getElementById("thinq-home")
                .classList.remove("callout-active");
              setTextBoxHome(null);
              document
                .getElementById("home-text-box")
                .classList.remove("callout-active");
            }}
          ></div>
          <div
            className="callout-btn"
            id="media"
            style={{
              backgroundColor: "rgba(255,0,153,0.4)",
              position: "absolute",
              height: "63px",
              width: "63px",
              top: "calc(50% + 164px)",
              left: "calc(50% + 47px)",
              zIndex: 19,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: 'url("./images/webos-cursor.png"), auto',
            }}
            onClick={() => {
              const el = document.getElementById("media").classList;
              if (el.contains("callout-active")) {
                el.remove("callout-active");
              } else {
                el.add("callout-active");
              }
            }}
            onMouseOver={() => {
              setActiveLinkHome("media");
              document.getElementById("media").classList.add("callout-active");
              setTextBoxHome(
                "Use your TV to display pictures or play your favorite music."
              );
              setTextBoxTitle("Media Player");
              document
                .getElementById("home-text-box")
                .classList.add("callout-active");
            }}
            onMouseLeave={() => {
              setActiveLinkHome(null);
              document
                .getElementById("media")
                .classList.remove("callout-active");
              setTextBoxHome(null);
              document
                .getElementById("home-text-box")
                .classList.remove("callout-active");
            }}
          ></div>
          {/* End new buttons */}

          <div
            className="callout-btn"
            id="content-store"
            style={{
              position: "absolute",
              backgroundColor: "rgba(255,0,153,0.4)",
              height: "63px",
              width: "63px",
              top: "calc(50% + 164px)",
              left: "calc(50% - 446px)",
              zIndex: 19,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: 'url("./images/webos-cursor.png"), auto',
            }}
            onClick={() => {
              const el = document.getElementById("content-store").classList;
              if (el.contains("callout-active")) {
                el.remove("callout-active");
              } else {
                el.add("callout-active");
              }
            }}
            onMouseOver={() => {
              setActiveLinkHome("content-store");
              document
                .getElementById("content-store")
                .classList.add("callout-active");
              setTextBoxHome("A portal to limitless premium content and apps.");
              setTextBoxTitle("Content Store");
              document
                .getElementById("home-text-box")
                .classList.add("callout-active");
            }}
            onMouseLeave={() => {
              setActiveLinkHome(null);
              document
                .getElementById("content-store")
                .classList.remove("callout-active");
              setTextBoxHome(null);
              document
                .getElementById("home-text-box")
                .classList.remove("callout-active");
            }}
          ></div>
          <div
            className="callout-btn"
            id="content-providers"
            style={{
              position: "absolute",
              backgroundColor: "rgba(255,0,153,0.4)",
              height: "63px",
              width: "350px",
              top: "calc(50% + 163px)",
              left: "calc(50% + -378px)",
              zIndex: 19,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: 'url("./images/webos-cursor.png"), auto',
            }}
            onClick={() => {
              const el = document.getElementById("content-providers").classList;
              if (el.contains("callout-active")) {
                el.remove("callout-active");
              } else {
                el.add("callout-active");
              }
            }}
            onMouseOver={() => {
              setActiveLinkHome("content-providers");
              document
                .getElementById("content-providers")
                .classList.add("callout-active");
              setTextBoxHome(
                "View content from all your favorite providers and the webOS TV LG Channels service."
              );
              setTextBoxTitle("Content Providers");
              document
                .getElementById("home-text-box")
                .classList.add("callout-active");
            }}
            onMouseLeave={() => {
              setActiveLinkHome(null);
              document
                .getElementById("content-providers")
                .classList.remove("callout-active");
              setTextBoxHome(null);
              document
                .getElementById("home-text-box")
                .classList.remove("callout-active");
            }}
          ></div>
          <div
            className="callout-btn"
            id="web-browser"
            style={{
              position: "absolute",
              backgroundColor: "rgba(255,0,153,0.4)",
              height: "63px",
              width: "63px",
              top: "calc(50% + 164px)",
              left: "calc(50% - 23px)",
              zIndex: 19,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: 'url("./images/webos-cursor.png"), auto',
            }}
            onClick={() => {
              const el = document.getElementById("web-browser").classList;
              if (el.contains("callout-active")) {
                el.remove("callout-active");
              } else {
                el.add("callout-active");
              }
            }}
            onMouseOver={() => {
              setActiveLinkHome("web-browser");
              document
                .getElementById("web-browser")
                .classList.add("callout-active");
              setTextBoxHome(
                "Use your TV for the web using the webOS TV integrated web browser."
              );
              setTextBoxTitle("Web Browser");
              document
                .getElementById("home-text-box")
                .classList.add("callout-active");
            }}
            onMouseLeave={() => {
              setActiveLinkHome(null);
              document
                .getElementById("web-browser")
                .classList.remove("callout-active");
              setTextBoxHome(null);
              document
                .getElementById("home-text-box")
                .classList.remove("callout-active");
            }}
          ></div>

          <div
            className="callout-text"
            id="home-text-box"
            style={{
              position: "absolute",
              height: "max-content",
              width: "455px",
              backgroundColor: "rgba(0,0,0,0.85)",
              top:
                activeLinkHome !== "sponsored"
                  ? activeLinkHome === "thinq-home" ||
                    activeLinkHome === "recents" ||
                    activeLinkHome === "search"
                    ? "calc(50% + 49px)"
                    : activeLinkHome === "live-tv" || activeLinkHome === "edit"
                    ? "calc(50% + 69px)"
                    : activeLinkHome === "content-store" ||
                      activeLinkHome === "media"
                    ? "calc(50% + 69px)"
                    : "calc(50% + 49px)"
                  : activeLinkHome === "settings"
                  ? "calc(50% + 49px)"
                  : "calc(50% - 50px)",
              pointerEvents: "none",
              left:
                activeLinkHome === "quick-access-bar"
                  ? "calc(50% - 216px)"
                  : activeLinkHome === "content-providers"
                  ? "calc(50% - 350px)"
                  : activeLinkHome === "content-store"
                  ? "calc(50% - 450px)"
                  : activeLinkHome === "search"
                  ? "calc(50% - 167px)"
                  : activeLinkHome === "thinq-home"
                  ? "calc(50% - 157px)"
                  : activeLinkHome === "live-tv"
                  ? "calc(50% - 248px)"
                  : activeLinkHome === "recents"
                  ? "calc(50% - 195px)"
                  : activeLinkHome === "media"
                  ? "calc(50% - 174px)"
                  : activeLinkHome === "web-browser"
                  ? "calc(50% - 210px)"
                  : activeLinkHome === "edit"
                  ? "calc(50% - 32px)"
                  : activeLinkHome === "settings"
                  ? "calc(50% + 26px)"
                  : "calc(50% + 20px)",
              zIndex: !activeLinkHome !== "quick-access-bar" ? 21 : 18,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              borderRadius: "2px",
              // border: "4px solid rgba(195,0,0,1)",
            }}
          >
            <h1
              style={{
                color: "rgb(200, 200, 200)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                textAlign: "left",
                marginLeft: "1.5rem",
                paddingBottom: "0px",
                marginBottom: "0px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
              }}
            >
              {textBoxTitle}
            </h1>
            <h2
              style={{
                color: "rgb(200, 200, 200)",
                padding: "0.5rem 2rem",
                borderRadius: "4px",
                fontSize: "16px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
              }}
            >
              {textBoxHome}
            </h2>
          </div>
        </>
      )}
      {page === "magic_remote" && (
        <>
          <div
            className="remote-dark"
            style={{
              zIndex: 2,
              left: "calc(50% - 436px)",
              top: "calc(50% - 304px)",
            }}
          >
            {/* <SvgLines animate={300} stagger={100} duration={1200}> */}
            <svg id="calloutsvg" viewBox="0 0 879 580">
              <path
                desc="set-top"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M765.7,95.3l-38.1-23.9l28.2-19.9l38.7,22.7L765.7,95.3z"
              />
              <path
                desc="quick-access"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M547.6,81.1l102.2-46.7l115,67.8l-95.4,55l-45.9-34.1L588,151.5l-45.3-30.1
                L578.6,97L547.6,81.1z"
              />

              <path
                desc="voice"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M485.8,205.5l-37.4-21.8l44.9-32.2l38.3,20.8L485.8,205.5z"
              />
              <path
                desc="home"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M448.4,168.8l-25.5,17.9l-37-17.2l26.9-16.2L448.4,168.8z"
              />

              <path
                desc="settings"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M541.3,239.5l-23.7,20.6l-40.3-34.6l24.3-19.1L541.3,239.5z"
              />
              <path
                desc="scroll"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M380.8,302.2l-79-50.3l88.8-58.5l79.1,48L380.8,302.2z"
              />

              <path
                desc="guide"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M370.1,358L330,325.6l24.8-19.3l38.4,30.8L370.1,358z"
              />
              <path
                desc="back"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M297.2,263.5l-20.2,19.8l-34.1-19.3l20.9-18.9L297.2,263.5z"
              />
              <path
                desc="netflix"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M273.2,285.5
                l-43.6,36.2
                l-35.4-24.5
                l40.8-32.3
                L273.2,285.5z"
              />
              <path
                desc="prime"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="
                M 359.6 354.7
                l -40.1 36.7
                l -40.1 -36.7
                l 38.6 -34.7
                L 359.6 354.7z
                "
              />
              <path
                desc="movies"
                fill="none"
                stroke="#FF0099"
                strokeWidth={1}
                d="M198.5,345.9l-22.2,19.8l-32.1-19.3l20.9-18.9L198.5,345.9z"
              />
            </svg>
            {/* </SvgLines> */}
          </div>
          <div
            className="remote-dark"
            style={{
              zIndex: 4,
              left: "calc(50% - 436px)",
              top: "calc(50% - 304px)",
              pointerEvents: "all",
            }}
          >
            <svg viewBox="0 0 879 580">
              <path
                className="callout-btn-overlay"
                id="set-top"
                opacity="0.49"
                fill="#a52446"
                d="M765.7,95.3l-38.1-23.9l28.2-19.9l38.7,22.7L765.7,95.3z"
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("set-top");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
              />
              <path
                className="callout-btn-overlay"
                id="back"
                opacity="0.49"
                fill="#a52446"
                d="M297.2,263.5l-20.2,19.8l-34.1-19.3l20.9-18.9L297.2,263.5z"
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("back");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
              />
              <path
                className="callout-btn-overlay"
                id="movies"
                opacity="0.49"
                fill="#a52446"
                d="M198.5,345.9l-22.2,19.8l-32.1-19.3l20.9-18.9L198.5,345.9z"
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("movies");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
              />

              <path
                className="callout-btn-overlay"
                id="guide"
                opacity="0.49"
                fill="#a52446"
                d="M370.1,358L330,325.6l24.8-19.3l38.4,30.8L370.1,358z"
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("guide");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
              />
              <path
                className="callout-btn-overlay"
                id="quick-access"
                opacity="0.49"
                fill="#a52446"
                d="M547.6,81.1l102.2-46.7l115,67.8l-95.4,55l-45.9-34.1L588,151.5l-45.3-30.1
							L578.6,97L547.6,81.1z"
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("quick-access");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
              />
              {/* Streaming providers */}
              <g
                className="callout-btn-overlay"
                id="streaming-providers"
                style={{ cursor: "pointer" }}
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("streaming-providers");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
              >
                <path
                  opacity="0.49"
                  fill="#a52446"
                  d="M273.2,285.5
                l-43.6,36.2
                l-35.4-24.5
                l40.8-32.3
                L273.2,285.5z"
                />
                <path
                  opacity="0.49"
                  fill="#a52446"
                  d="
                M 359.6 354.7
                l -40.1 36.7
                l -40.1 -36.7
                l 38.6 -34.7
                L 359.6 354.7z
                "
                />
              </g>
              {/* Scroll Wheel */}
              <path
                className="callout-btn-overlay"
                opacity="0.49"
                fill="#a52446"
                d="M380.8,302.2l-79-50.3l88.8-58.5l79.1,48L380.8,302.2z"
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("scroll-wheel");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
              />
              {/* settings button overlay*/}
              <path
                className="callout-btn-overlay"
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("settings-button");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
                opacity="0.49"
                fill="#a52446"
                d="M541.3,239.5l-23.7,20.6l-40.3-34.6l24.3-19.1L541.3,239.5z"
              />
              <path
                className="callout-btn-overlay"
                id="speech-commands"
                opacity="0.49"
                fill="#a52446"
                d="M485.8,205.5l-37.4-21.8l44.9-32.2l38.3,20.8L485.8,205.5z"
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("speech-commands");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
              />
              {/* home button overlay*/}
              <path
                className="callout-btn-overlay"
                onMouseOver={() => {
                  setHideTextBox(false);
                  setActiveLinkRemote("home-button");
                }}
                onMouseLeave={() => {
                  setHideTextBox(true);
                  setActiveLinkRemote(null);
                }}
                opacity="0.49"
                fill="#a52446"
                d="M448.4,168.8l-25.5,17.9l-37-17.2l26.9-16.2L448.4,168.8z"
              />
            </svg>
          </div>
        </>
      )}
      <div id="remote-abs">
        <div id="remote-callouts">
          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "scroll-wheel"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "400px",
              position: "absolute",
              top: "calc(50% - 40px)",
              left: "calc(50% + 55px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Scroll Wheel
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Navigate menus with ease by scrolling up or down to quickly find
              your favorite content.
            </h2>
          </div>
          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "speech-commands"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "400px",
              position: "absolute",
              top: "calc(50% - 300px)",
              left: "calc(50% - 345px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Voice Commands
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Accessing your favorite content has never been easier. Just tell
              LG what you're looking for and let ThinQ AI do the rest.
            </h2>
          </div>

          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "home-button"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "400px",
              position: "absolute",
              top: "calc(50% - 260px)",
              left: "calc(50% - 375px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Home button
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Quickly access webOS TV home from anywhere.
            </h2>
          </div>

          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "settings-button"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "400px",
              position: "absolute",
              top: "calc(50% - 20px)",
              left: "calc(50% + 45px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Settings Button
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Customize your tv viewing experience with a powerful range of
              settings in webOS TV.
            </h2>
          </div>

          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "streaming-providers"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "400px",
              position: "absolute",
              top: "calc(50% - 160px)",
              left: "calc(50% - 550px)",
              zIndex: 1000,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Popular Streaming Providers
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Quickly access popular streaming providers with just the touch of
              a button! (Varies by region)
            </h2>
          </div>
          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "ai-assistants"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "450px",
              position: "absolute",
              top: "calc(50% + 110px)",
              left: "calc(50% - 95px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              AI Assistants
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Control your home smart devices connected through Amazon Alexa and
              Google Assistant through your TV remote giving you total access
              and control of your home.
            </h2>
          </div>
          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "quick-access"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "450px",
              position: "absolute",
              top: "calc(50% - 320px)",
              left: "calc(50% - 315px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Quick Access
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Long press a number on the number pad for quick and easy access to
              your favorite apps.
            </h2>
          </div>
          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "guide"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "450px",
              position: "absolute",
              top: "calc(50% + 70px)",
              left: "calc(50% - 35px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Guide
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Navigate and see what's playing on Live TV from LG Channels.
            </h2>
          </div>
          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "back"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "450px",
              position: "absolute",
              top: "calc(50% - 160px)",
              left: "calc(50% - 550px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Back Button
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Opens up the previous screen.
            </h2>
          </div>
          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "set-top"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "450px",
              position: "absolute",
              top: "calc(50% - 150px)",
              left: "calc(50% + 205px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Set-Top Box Setup
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Setup your set-top box from your remote using the webOS TV and the
              magic remote.
            </h2>
          </div>
          <div
            className={
              hideTextBox
                ? "callout-text"
                : activeLinkRemote === "movies"
                ? "callout-text callout-active"
                : "callout-text"
            }
            style={{
              height: "auto",
              width: "450px",
              position: "absolute",
              top: "calc(50% + 160px)",
              left: "calc(50% - 135px)",
              zIndex: 10,
              backgroundColor: "rgba(255,255,255, 0.75)",
              color: "black",
            }}
          >
            <h1
              style={{
                color: "rgb(40,40,40)",
                padding: "0.5rem",
                borderRadius: "4px",
                fontSize: "18px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 600,
                textAlign: "left",
                marginLeft: "1.5rem",
                marginTop: "10px",
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Movies
            </h1>
            <h2
              style={{
                color: "rgb(40,40,40)",
                fontSize: "16px",
                fontFamily: "LG_Smart_Regular",
                fontWeight: 300,
                padding: "0.5rem",
                borderRadius: "4px",
                textAlign: "left",
                paddingTop: "0px",
                marginTop: "5px",
                marginLeft: "1.5rem",
                marginRight: "1.5rem",
                marginBottom: "11px",
              }}
            >
              Search for movies with the press of a button on the magic remote.
            </h2>
          </div>
        </div>
      </div>
    </>
  );
}
